import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import config from 'cfg';
import NoteAddIcon from 'material-ui/svg-icons/action/note-add';
import InfoIcon from 'material-ui/svg-icons/action/info';
import DeleteForeverIcon from 'material-ui/svg-icons/action/delete-forever';
import { Link } from 'react-router';

class Stats extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            widgets: [],
            category: 'drafts',
            isLoading: true,
            saveSuccess: false,
            saveError: false
        };

        this.loadData();
    }

    loadData = () => {
        var { user } = this.context;

        if (!user || !user.client) return null;

        return fetch(`${config.dash.api.host}/api/widgets?access_token=${auth.getAccessToken()}`)
            .then(response => response.json())
            .then(body => this.setState({ widgets: body.widgets, isLoading: false }))
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isLoading: false });
            });
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired
    };

    renderIndications() {
        return [
            <rmd.Snackbar
                open={this.state.saveSuccess}
                key="save-success-snack"
                message="Widget instance(s) has been successfully deleted"
                autoHideDuration={4000}
            />,
            <rmd.Snackbar
                open={this.state.saveError}
                key="save-error-snack"
                className="snackbar-error"
                message="Server error. Unable to delete widget"
                action="close"
                onActionTouchTap={() => this.setState({ saveError: false })}
            />
        ];
    }

    cleanDrafts = () => {
        let params = {
            userId: this.context.user._id
        };
        let url = `${config.dash.api.host}/api/widgets/drafts`;
        this.setState({ isSaving: true });
        return fetch(url, {
            method: 'delete',
            body: JSON.stringify(params),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(() => {
                var widgets = this.state.widgets.filter(w => w.template);
                this.setState({ widgets, saveSuccess: true });
            })
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isSaving: false, saveError: true });
            });
    };

    deleteWidget(widget) {
        let params = {
            userId: widget.userId
        };
        let url = `${config.dash.api.host}/api/widgets/${widget._id}`;
        this.setState({ isSaving: true });
        return fetch(url, {
            method: 'delete',
            body: JSON.stringify(params),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(() => {
                var widgets = this.state.widgets.filter(w => w._id !== widget._id);
                this.setState({ widgets, saveSuccess: true });
            })
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isSaving: false, saveError: true });
            });
    }

    render() {
        var { user, router } = this.context;
        var { category } = this.state;

        var widgets = _.chain(this.state.widgets)
            .map(widget => {
                widget.lastWeekPageViews = (widget.lastWeekStats || []).reduce((sum, val) => sum + val.pageviews, 0);
                return widget;
            })
            .orderBy('lastWeekPageViews', 'desc')
            .value();

        return (
            <div className="home">
                <rmd.Card>
                    <rmd.Table>
                        <rmd.TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <rmd.TableRow>
                                <rmd.TableHeaderColumn>WIID</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn>Widget Name</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn>Created</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn style={{ width: '30%' }}>Locations</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn>Page views (last week)</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn>Page views sum</rmd.TableHeaderColumn>
                                <rmd.TableHeaderColumn />
                            </rmd.TableRow>
                        </rmd.TableHeader>
                        <rmd.TableBody displayRowCheckbox={false}>
                            {this.state.isLoading && (
                                <rmd.TableRow>
                                    <rmd.TableRowColumn>Loading...</rmd.TableRowColumn>
                                </rmd.TableRow>
                            )}
                            {!this.state.widgets.length &&
                                !this.state.isLoading && (
                                    <rmd.TableRow>
                                        <rmd.TableRowColumn>No widget instances have been saved yet</rmd.TableRowColumn>
                                    </rmd.TableRow>
                                )}
                            {widgets.map(widget => {
                                var queryString = Object.keys(widget.props || {})
                                    .map(prop => {
                                        return prop + '=' + encodeURIComponent(widget.props[prop]) + '&';
                                    })
                                    .join('');
                                var cloneLink = `/widgets/${widget.widgetName}/customizer?${queryString}`;
                                // var editLink = `/widgets/${widget.widgetName}/customizer?${queryString}wiid=${widget._id}`;
                                var statsLink = `/widgets/${widget._id}/statistics`;
                                var topLocationsByPageViews = _.chain(widget.lastWeekStats || [])
                                    .sortBy(location => location.pageviews)
                                    .reverse()
                                    .slice(0, 3)
                                    .value();

                                var locations = topLocationsByPageViews.map(row => (
                                    <a style={{ display: 'block' }} href={row.screenName}>
                                        {row.screenName}
                                    </a>
                                ));

                                var pageviews = topLocationsByPageViews.map(row => <div>{row.pageviews}</div>);

                                return (
                                    <rmd.TableRow key={widget._id}>
                                        <rmd.TableRowColumn>{widget._id}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn>{widget.widgetName}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn>{widget.createdAt}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn style={{ width: '30%' }}>{locations}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn>{pageviews}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn>{widget.lastWeekPageViews}</rmd.TableRowColumn>
                                        <rmd.TableRowColumn
                                            style={{
                                                overflow: 'visible',
                                                textAlign: 'right'
                                            }}
                                        >
                                            <Link to={statsLink}>
                                                <rmd.IconButton tooltip="Stats">
                                                    <InfoIcon />
                                                </rmd.IconButton>
                                            </Link>
                                            <Link to={cloneLink}>
                                                <rmd.IconButton tooltip="Clone">
                                                    <NoteAddIcon />
                                                </rmd.IconButton>
                                            </Link>
                                            <rmd.IconButton
                                                tooltip="Delete"
                                                onClick={this.deleteWidget.bind(this, widget)}
                                            >
                                                <DeleteForeverIcon />
                                            </rmd.IconButton>
                                        </rmd.TableRowColumn>
                                    </rmd.TableRow>
                                );
                            })}
                        </rmd.TableBody>
                    </rmd.Table>
                </rmd.Card>
                {this.renderIndications()}
            </div>
        );
    }
}

export default Stats;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetListStatsByUser.js
 **/